import { FC } from 'react';
import { Modal, Table } from 'antd';
import moment from 'moment';
import { formatMoney } from "../../../../helpers/formatter";

interface InterestBreakdownModalProps {
  visible: boolean;
  onCancel: () => void;
  interestBreakdown: any[];
  currency: string;
}

const InterestBreakdownModal: FC<InterestBreakdownModalProps> = ({
  visible,
  onCancel,
  interestBreakdown,
  currency
}) => {
  // Define table columns
  const columns = [
    {
      title: 'Payment Date',
      dataIndex: 'endDate',
      key: 'date',
      render: (text: string) => moment(text).format('ll')
    },
    {
      title: `Interest Amount (${currency})`,
      dataIndex: 'interestAmount',
      key: 'amount',
      render: (text: number) => formatMoney(text || 0, ''),
      align: 'right' as 'right',
    },
  ];

  return (
    <Modal
      title="Interest Payment Breakdown"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      centered
      closable={true}
      closeIcon={<span style={{ fontSize: '24px' }}>×</span>}
    >
      <Table
        columns={columns}
        dataSource={interestBreakdown?.map((item, index) => ({
          ...item,
          key: index,
        })) || []}
        pagination={false}
        size="middle"
        scroll={{ y: 300 }}
        summary={(pageData) => {
          let totalInterest = 0;

          pageData.forEach(({ interestAmount }) => {
            totalInterest += Number(interestAmount) || 0;
          });

          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}><strong>Total Interest</strong></Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  <strong>{formatMoney(totalInterest, currency)}</strong>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
    </Modal>
  );
};

export default InterestBreakdownModal;
